module.exports = __webpack_public_path__ + "static/media/1005863.85ebe4e3.jpg";